import { createSlice } from '@reduxjs/toolkit';

const buildRefreshSlice = createSlice({
  name: 'buildRefresh',
  initialState: {
    open: false,
    serverBuildVersion: null,
  },
  reducers: {
    openStaleBuildDialog: (state, action) => {
      state.open = true;
      state.serverBuildVersion = action.payload.serverBuildVersion;
    },
  },
});

export const { openStaleBuildDialog } = buildRefreshSlice.actions;
export const selectStaleBuildOpen = (state) => state.buildRefresh.open;
export const selectStaleBuildServerVersion = (state) => state.buildRefresh.serverBuildVersion;

export default buildRefreshSlice.reducer;
